<template>
	<div class="userpage" :class="($store.state.mode === 'dark') ? 'userpage-dark' : 'false'">
		<div class="navbar" :class="($store.state.mode === 'dark') ? 'dark-header-active' : 'false'">
			<i v-on:click="$router.go(-1)" class="material-icons">arrow_back</i>
			<div class="title">
				Support
			</div>
			<i @click="openURL('mailto:kyangbesar@gmail.com')" class="material-icons">email</i>
		</div>
		<div class="wrapper">
			<div class="head">	
				<div class="title">
					App is not working properly
				</div>
				<span class="desc">follow this steps</span>
			</div>
			<div class="body-content">
				<div class="sub-title">
					<div class="features"><span class="dot"></span> Reload the app.</div>
					<div class="features"><span class="dot"></span> Check your data.</div>
					<div class="features"><span class="dot"></span> Readded app from browser.</div>
					<div class="features"><span class="dot"></span> Make sure your audio volume is up and working.</div>
				</div>
			</div>
			<div class="body-content">
				<div class="title">
					Wanna become creator?
				</div>
				<span class="desc">Contact us then we verify your data</span>
			</div>
			<div class="body-content" @click="openURL('mailto:kyangbesar@gmail.com')">
				<div class="title">
					Have questions?
				</div>
				<span class="desc">Write to us at <u>kyangbesar@gmail.com</u></span>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			mode: null,
		}
	},
	methods: {
		openURL: function(url) {
			window.open(url,'_blank')
		}
	},
	mounted() {
		this.mode = localStorage.mode
	},

};
</script>
<style lang="scss" scoped>
.userpage.userpage-dark {
	background-color: #000;
	color: #fff;
}
.userpage {
	position: absolute;
	width: 100%;
	padding-bottom: 3.4rem;
	background-color: #fff;
	color: #000;
}
.navbar.dark-header-active {
	backdrop-filter: blur(1px);
	background-image: linear-gradient(rgb(0,0,0), transparent);
}
.navbar.false {
	background-image: linear-gradient(rgb(255,255,255), rgb(255,255,255));
	box-shadow: 0 1px 10px rgba(0,0,0, .03);
}
.navbar {
	z-index: 99;
	position: fixed;
	width: 100%;
	height: 4rem;
	padding: 0 1.5rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	.title {
		font-size: 14px;
	}
}
.wrapper {
	padding: 5rem 1.5rem 0;
	.content {
	}
	.body-content {
		margin-top: 20px;
	}
	.title {
		font-size: 16px;
		font-weight: bold;
	}
	.sub-title {
		font-size: 10px;
		letter-spacing: .020rem;
		.features {
			padding: .25rem 0;
		}
	}
	.desc {
		font-size: 10px;
		opacity: 0.7;
	}
}
.dot {
	margin: 2px 2px;
	height: 4px;
	width: 4px;
	background-color: rgb(36, 179, 131);
	border-radius: 50%;
	display: inline-block;
}
</style>